import classNames from 'classnames';
import { useEffect } from 'react';
import { Heading } from '@acb_devel/design-system';
import { Text } from '@acb_devel/design-system';
import { getRegistrations } from '@services/registrations';
import { Badge } from '@acb_devel/design-system';
import { useRegistrationsContext } from '@contexts/RegistrationsContext';
import { RegistrationStatus } from '@services/registrations';

import styles from './RegistrationsCard.module.scss';

export function RegistrationsCard({ className }: { className?: string }) {
  const { registrations, setRegistrations } = useRegistrationsContext();

  useEffect(() => {
    getRegistrations()
      .then((data) => {
        setRegistrations(
          data.results.filter(
            (registration) => new Date(registration.event.endEvent) > new Date()
          )
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, [setRegistrations]);

  if (registrations.length === 0) {
    return null;
  }

  return (
    <div className={classNames(styles.card, className)}>
      <Heading as="h2" variant="heading-1">
        Tus inscripciones
      </Heading>
      <div className={styles.card__registrations}>
        {registrations.map((registration) => (
          <div key={registration.id} className={styles.card__registration}>
            <div className={styles.card__registrationInfo}>
              <Text variant="body-1" className={styles.card__registrationText}>
                {registration.event.fullName}
              </Text>
            </div>
            {registration.status === RegistrationStatus.PENDING && (
              <Badge variant="accent">Enviada</Badge>
            )}
            {(registration.status === RegistrationStatus.SCHEDULED ||
              registration.status === RegistrationStatus.INTERVIEWED) && (
              <Badge variant="info">En curso</Badge>
            )}
            {registration.status === RegistrationStatus.CONFIRMED && (
              <Badge variant="success">Confirmada</Badge>
            )}
            {registration.status === RegistrationStatus.REJECTED && (
              <Badge variant="error">Rechazada</Badge>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
